import styled, { css } from "styled-components";
import { DEFAULT_HORIZONTAL_RECTANGLE_WIDTH } from ".";

const horizontalRectanglePositions = {
  1: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(389px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(118px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  2: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(293px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    right: ${`calc(154px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  3: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => css`
    bottom: ${`calc(195px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    right: ${`calc(188px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  4: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(164px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    right: ${`calc(201px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  5: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(416px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(816px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  6: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(246px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    left: ${`calc(130px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  7: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(395px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    right: ${`calc(114px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  8: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(395px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    right: ${`calc(217px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  9: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(300px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    right: ${`calc(128px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
  10: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => css`
    top: ${`calc(300px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    right: ${`calc(187px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
  `,
};

export const HorizontalRectangleContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${(size * 156.3) / 300}px`};

  ${({ size, label, shape }) => {
    return (
      size !== 1200 &&
      css`
        background-color: #f2f2f5;
        &::after {
          content: ${`"${label}"`};
          position: absolute;
          font-family: "Poppins";
          font-weight: 800;
          font-size: ${`calc(12.65px * ${size} / ${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH})`};
          color: #3a3a3c;

          ${horizontalRectanglePositions[shape]({ size })}
        }
      `
    );
  }}
`;

export const HorizontalRectangleMask = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
`;

export const HorizontalRectangleImage = styled.img`
  position: absolute;
  object-fit: cover;
  z-index: 10;
  ${({ top, left, size, x_axis }) => {
    return css`
      width: ${`${size.width}px`};
      height: ${`${size.height}px`};
      top: ${`${top}px`};
      left: ${`${left}px`};
      object-position: ${`${x_axis}% 50%`};
    `;
  }};
`;

export const DraggableHorizontalRectangleContainer = styled.div`
  position: relative;
  overflow: hidden;
  ${({ size, background = "#fff" }) => {
    return css`
      width: ${`${size}px`};
      height: ${`${size / (300 / 157)}px`};
      background-color: ${background};
    `;
  }};
`;
